/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ManagerOwnableUpgradeable,
  ManagerOwnableUpgradeableInterface,
} from "../ManagerOwnableUpgradeable";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "role",
        type: "bool",
      },
    ],
    name: "ManagerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldRoot",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newRoot",
        type: "address",
      },
    ],
    name: "RootOwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "_root",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isManager",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "root",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "manager",
        type: "address",
      },
      {
        internalType: "bool",
        name: "role",
        type: "bool",
      },
    ],
    name: "setManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferRootOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ManagerOwnableUpgradeable__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ManagerOwnableUpgradeable> {
    return super.deploy(overrides || {}) as Promise<ManagerOwnableUpgradeable>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ManagerOwnableUpgradeable {
    return super.attach(address) as ManagerOwnableUpgradeable;
  }
  connect(signer: Signer): ManagerOwnableUpgradeable__factory {
    return super.connect(signer) as ManagerOwnableUpgradeable__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerOwnableUpgradeableInterface {
    return new utils.Interface(_abi) as ManagerOwnableUpgradeableInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerOwnableUpgradeable {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ManagerOwnableUpgradeable;
  }
}
